module.exports = __webpack_public_path__ + "img/wallet-blue-grey.349fd8fe.svg";